
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/book-biking",
      function () {
        return require("private-next-pages/book-biking.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/book-biking"])
      });
    }
  